import { makeStyles } from "@material-ui/core"

type UseStylesProps = {
	backgroundColor: string
	fontColor: string
	size: number
}

const useStyles = makeStyles({
	counterChip: {
		height: (props: UseStylesProps) => props.size,
		width: (props: UseStylesProps) => props.size,
		backgroundColor: (props: UseStylesProps) => props.backgroundColor,
		"& span": {
			textOverflow: "clip",
			color: (props: UseStylesProps) => props.fontColor,
			padding: 0
		}
	}
})

export default useStyles
